module.exports = __webpack_public_path__ + "static/media/pdf-view.1c9a0c4e.svg";